export const TOAST_NOTIFICATION_STORE_FIELDS = {
  EVENT_COMMENT: 'focusedComment'
};
